module.exports = __webpack_public_path__ + "img/airplane.1659e771.png";